// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Shalani Chethana
 * @Date 24/01/2025
 */

 .Footer_footerMainContainer__Yygpn{
  padding: 50px 50px 50px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: rgb(0, 98, 163);
  margin-top: -10px;

 }

a{
  text-decoration: none;
}

.Footer_logo__\\+SElo {
 margin-bottom: 0.75rem;
}

.Footer_description__47PAv {
  color: #ffffff;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
}

.Footer_footerHeading__mpgcJ {
  color: #ffffff;
  font-size: 1.2rem;
  font-family: "Livvic", serif;
  font-style: normal;
  font-weight: 500;
  line-height: 2rem;
}

.Footer_footerLinks__NKkj1 {
  color: #ffffff;
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 400;
  margin-top: 0.5rem;
  width: 13rem;
}

.Footer_footerSection__kvdy9{
  display: flex;
  flex-direction: column;
  margin-bottom: 4rem;
}
.Footer_footerMapImgComp__olOHF{
  height: 200px;
}
.Footer_footerLogoSection__IdbLt {
  display: flex;
  flex-direction: column;
}

.Footer_footerBelow__1f5Ps{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 0.2rem;
}

.Footer_footerCopyright__XR1DK a {
  display: inline-block;
  margin-right: 2rem;
  color: #ffffff;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
}

.Footer_footerBelowLinks__tv3eG{
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  align-items: center;
  /* text-align: center; */
}
.Footer_footerFollower__EGHSd{
  color: #ffffff;
  font-size: 1.2rem;
  font-family: "Livvic", serif;
  font-style: normal;
  font-weight: 500;
  margin-bottom: 0px;
}
.Footer_icon__m\\+93W {
  color: #ffff;
  font-size: 20px;
  margin: 0 5px;
}
.Footer_copyRightTxt__gmw\\+K{
  font-size: 10px;
  color: #bcbbbb;
  margin-left: 0px;
}
.Footer_footerMobileSection__CJlfV , .Footer_footerMobileSectionMap__P\\+qPh{
  visibility: hidden;
  display: none;
}
/* @media screen and (max-width: 770px){
  .icon{
    font-size: 14px;
    line-height: 20px;
  }
  .footerBelow{
    flex-direction: column;
    justify-content: left;
  }

  .footerLogoSection .description{
    font-size: 0.9rem;
  }

  .footerHeading {
    font-size: 1rem;
  }

  .footerLinks {
    font-size: 0.75rem;
    width: 7rem
  }
  .footerMainContainer{
    padding: 30px 30px 10px 30px;
   }
}


@media screen and (max-width: 600px){
 
  .logo {
    width: 4.5rem;
    height: 1.5rem;
}
  .icon{
    font-size: 14px;
    margin: 0 2px;
    line-height: 10px;
  }

  .footerBelow{
    flex-direction: column;
    justify-content: left;
  }

  .footerLogoSection .description{
    display: none;
  }

  .footerMainContainer{
    padding: 50px 5px 10px 5px;
   }

   .footerHeading {
    font-size: 16px;
  }

  .footerLinks {
    font-size: 11px;
    width: 50px
  }
  } */


  
@media (max-width:1024px){
  .Footer_footerMainContainer__Yygpn{
    padding: 10px 10px 10px 10px;
   }
   .Footer_copyRightTxt__gmw\\+K{
    margin-left: 0px;
  }
}
@media (max-width:770px){
  .Footer_footerMainContainer__Yygpn{
    padding: 20px ;
   }
   .Footer_logo__\\+SElo {
    width: 4.5rem;
    height: 1.5rem;
}
  .Footer_icon__m\\+93W{
    font-size: 10px;
    margin: 0 2px;
    line-height: 10px;
  }
  .Footer_footerHeading__mpgcJ {
    font-size: 12px;
  }

  .Footer_footerLinks__NKkj1 {
    font-size: 10px;
    /* width: 50px */
  }
  .Footer_description__47PAv{
    font-size: 11px;
    line-height: 16px;
  }
}
@media (max-width:480px){
  .Footer_footerGridContainer__aWHZg{
    flex-direction: column;
  }
  .Footer_footerLogoSection__IdbLt{
    width: 300px;
    padding-left: 0px;
  }
  .Footer_footerMobileSection__CJlfV{
    visibility: visible;
    display: flex;
    flex-direction: row;
    width: 350px;
    padding: 20px;
  }
  .Footer_footerMobileSectionMap__P\\+qPh{
    visibility: visible;
    display: flex;
    width: 200px;

  }
  .Footer_footerSection__kvdy9{
    display: none;
  }
  .Footer_footerSectionMobile__kHu4Y , .Footer_footerSectionMobileCompany__WzzP0{
    display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  
  }
  .Footer_footerSectionMobileCompany__WzzP0{
    padding-left: 100px;
  }
  .Footer_footerMapImgComp__olOHF{
    height: 150px;
    margin-bottom: 50px;
    
}
}
`, "",{"version":3,"sources":["webpack://./src/components/footer/Footer.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;CAED;EACC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,iBAAiB;;CAElB;;AAED;EACE,qBAAqB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA6DK;;;;AAIL;EACE;IACE,4BAA4B;GAC7B;GACA;IACC,gBAAgB;EAClB;AACF;AACA;EACE;IACE,cAAc;GACf;GACA;IACC,aAAa;IACb,cAAc;AAClB;EACE;IACE,eAAe;IACf,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,YAAY;;EAEd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf,sBAAsB;EACtB,mBAAmB;;EAEnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;;AAEvB;AACA","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Shalani Chethana\r\n * @Date 24/01/2025\r\n */\r\n\r\n .footerMainContainer{\r\n  padding: 50px 50px 50px 50px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  background-color: rgb(0, 98, 163);\r\n  margin-top: -10px;\r\n\r\n }\r\n\r\na{\r\n  text-decoration: none;\r\n}\r\n\r\n.logo {\r\n margin-bottom: 0.75rem;\r\n}\r\n\r\n.description {\r\n  color: #ffffff;\r\n  font-size: 1rem;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 1.5rem;\r\n}\r\n\r\n.footerHeading {\r\n  color: #ffffff;\r\n  font-size: 1.2rem;\r\n  font-family: \"Livvic\", serif;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 2rem;\r\n}\r\n\r\n.footerLinks {\r\n  color: #ffffff;\r\n  font-size: 0.9rem;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  margin-top: 0.5rem;\r\n  width: 13rem;\r\n}\r\n\r\n.footerSection{\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-bottom: 4rem;\r\n}\r\n.footerMapImgComp{\r\n  height: 200px;\r\n}\r\n.footerLogoSection {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.footerBelow{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.footerCopyright a {\r\n  display: inline-block;\r\n  margin-right: 2rem;\r\n  color: #ffffff;\r\n  font-size: 1rem;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n}\r\n\r\n.footerBelowLinks{\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin-top: 10px;\r\n  align-items: center;\r\n  /* text-align: center; */\r\n}\r\n.footerFollower{\r\n  color: #ffffff;\r\n  font-size: 1.2rem;\r\n  font-family: \"Livvic\", serif;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  margin-bottom: 0px;\r\n}\r\n.icon {\r\n  color: #ffff;\r\n  font-size: 20px;\r\n  margin: 0 5px;\r\n}\r\n.copyRightTxt{\r\n  font-size: 10px;\r\n  color: #bcbbbb;\r\n  margin-left: 0px;\r\n}\r\n.footerMobileSection , .footerMobileSectionMap{\r\n  visibility: hidden;\r\n  display: none;\r\n}\r\n/* @media screen and (max-width: 770px){\r\n  .icon{\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n  }\r\n  .footerBelow{\r\n    flex-direction: column;\r\n    justify-content: left;\r\n  }\r\n\r\n  .footerLogoSection .description{\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .footerHeading {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .footerLinks {\r\n    font-size: 0.75rem;\r\n    width: 7rem\r\n  }\r\n  .footerMainContainer{\r\n    padding: 30px 30px 10px 30px;\r\n   }\r\n}\r\n\r\n\r\n@media screen and (max-width: 600px){\r\n \r\n  .logo {\r\n    width: 4.5rem;\r\n    height: 1.5rem;\r\n}\r\n  .icon{\r\n    font-size: 14px;\r\n    margin: 0 2px;\r\n    line-height: 10px;\r\n  }\r\n\r\n  .footerBelow{\r\n    flex-direction: column;\r\n    justify-content: left;\r\n  }\r\n\r\n  .footerLogoSection .description{\r\n    display: none;\r\n  }\r\n\r\n  .footerMainContainer{\r\n    padding: 50px 5px 10px 5px;\r\n   }\r\n\r\n   .footerHeading {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .footerLinks {\r\n    font-size: 11px;\r\n    width: 50px\r\n  }\r\n  } */\r\n\r\n\r\n  \r\n@media (max-width:1024px){\r\n  .footerMainContainer{\r\n    padding: 10px 10px 10px 10px;\r\n   }\r\n   .copyRightTxt{\r\n    margin-left: 0px;\r\n  }\r\n}\r\n@media (max-width:770px){\r\n  .footerMainContainer{\r\n    padding: 20px ;\r\n   }\r\n   .logo {\r\n    width: 4.5rem;\r\n    height: 1.5rem;\r\n}\r\n  .icon{\r\n    font-size: 10px;\r\n    margin: 0 2px;\r\n    line-height: 10px;\r\n  }\r\n  .footerHeading {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .footerLinks {\r\n    font-size: 10px;\r\n    /* width: 50px */\r\n  }\r\n  .description{\r\n    font-size: 11px;\r\n    line-height: 16px;\r\n  }\r\n}\r\n@media (max-width:480px){\r\n  .footerGridContainer{\r\n    flex-direction: column;\r\n  }\r\n  .footerLogoSection{\r\n    width: 300px;\r\n    padding-left: 0px;\r\n  }\r\n  .footerMobileSection{\r\n    visibility: visible;\r\n    display: flex;\r\n    flex-direction: row;\r\n    width: 350px;\r\n    padding: 20px;\r\n  }\r\n  .footerMobileSectionMap{\r\n    visibility: visible;\r\n    display: flex;\r\n    width: 200px;\r\n\r\n  }\r\n  .footerSection{\r\n    display: none;\r\n  }\r\n  .footerSectionMobile , .footerSectionMobileCompany{\r\n    display: flex;\r\n  flex-direction: column;\r\n  margin-bottom: 1rem;\r\n  \r\n  }\r\n  .footerSectionMobileCompany{\r\n    padding-left: 100px;\r\n  }\r\n  .footerMapImgComp{\r\n    height: 150px;\r\n    margin-bottom: 50px;\r\n    \r\n}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerMainContainer": `Footer_footerMainContainer__Yygpn`,
	"logo": `Footer_logo__+SElo`,
	"description": `Footer_description__47PAv`,
	"footerHeading": `Footer_footerHeading__mpgcJ`,
	"footerLinks": `Footer_footerLinks__NKkj1`,
	"footerSection": `Footer_footerSection__kvdy9`,
	"footerMapImgComp": `Footer_footerMapImgComp__olOHF`,
	"footerLogoSection": `Footer_footerLogoSection__IdbLt`,
	"footerBelow": `Footer_footerBelow__1f5Ps`,
	"footerCopyright": `Footer_footerCopyright__XR1DK`,
	"footerBelowLinks": `Footer_footerBelowLinks__tv3eG`,
	"footerFollower": `Footer_footerFollower__EGHSd`,
	"icon": `Footer_icon__m+93W`,
	"copyRightTxt": `Footer_copyRightTxt__gmw+K`,
	"footerMobileSection": `Footer_footerMobileSection__CJlfV`,
	"footerMobileSectionMap": `Footer_footerMobileSectionMap__P+qPh`,
	"footerGridContainer": `Footer_footerGridContainer__aWHZg`,
	"footerSectionMobile": `Footer_footerSectionMobile__kHu4Y`,
	"footerSectionMobileCompany": `Footer_footerSectionMobileCompany__WzzP0`
};
export default ___CSS_LOADER_EXPORT___;
